<script lang="ts">
  import IncomingPaymentDetailView from '../../../components/admin/payments/IncomingPaymentDetailView.svelte';
  export let params: { uuid: string };
</script>

<IncomingPaymentDetailView paymentUuid={params.uuid} />

